/**
 * @file Reads the email and action query parameters that a sign-in link
 * or invite email carries.
 */
export type QueryParams = {
  email: string | null;
  action: string | null;
};

/**
 * Returns the email and action query parameters from the current URL.
 */
const getQueryParams = (): QueryParams => {
  const queryString = window.location.search;
  const queryParams = new URLSearchParams(queryString);

  const email = queryParams.get("email");
  const action = queryParams.get("action");

  const result = {
    email,
    action,
  };

  return result;
};

export default getQueryParams;
